import BreadCrumbLink from '@/modules/common/components/breadcrumb/breadcrumbLink'

export default class BreadCrumbData {
  links: Array<BreadCrumbLink> = []

  constructor (links: Array<BreadCrumbLink>) {
    this.links = links || []
  }
}
